// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* social media icon */
.social-icon.dark a {
  color: #232323;
}
.social-icon.light a {
  color: #fff;
}
.social-icon.xs, .social-icon.sm, .social-icon.md, .social-icon.lg, .social-icon.xl {
  list-style: none;
  padding: 0;
}
.social-icon.xs li, .social-icon.sm li, .social-icon.md li, .social-icon.lg li, .social-icon.xl li {
  display: inline-block;
}
.social-icon.xs li:first-child, .social-icon.sm li:first-child, .social-icon.md li:first-child, .social-icon.lg li:first-child, .social-icon.xl li:first-child {
  margin-left: 0;
}
.social-icon.xs li:last-child, .social-icon.sm li:last-child, .social-icon.md li:last-child, .social-icon.lg li:last-child, .social-icon.xl li:last-child {
  margin-right: 0;
}
.social-icon.xs a, .social-icon.sm a, .social-icon.md a, .social-icon.lg a, .social-icon.xl a {
  display: inline-block;
}
.social-icon.xs li {
  margin: 0 2px;
}
.social-icon.xs a {
  font-size: 14px;
  width: 30px;
  height: 30px;
  line-height: 30px;
}
.social-icon.sm li {
  margin: 0 5px;
}
.social-icon.sm a {
  font-size: 16px;
  width: 40px;
  height: 40px;
  line-height: 40px;
}
.social-icon.md li {
  margin: 0 8px;
}
.social-icon.md a {
  font-size: 20px;
  width: 50px;
  height: 50px;
  line-height: 50px;
}
.social-icon.lg li {
  margin-left: 10px;
  margin-right: 10px;
}
.social-icon.lg a {
  font-size: 24px;
  width: 60px;
  height: 60px;
  line-height: 60px;
}
.social-icon.xl li {
  margin: 0 12px;
}
.social-icon.xl a {
  font-size: 30px;
  width: 70px;
  height: 70px;
  line-height: 70px;
}

.social-icon-style-01 {
  display: flex;
  align-items: center;
}
.social-icon-style-01.dark a {
  color: #232323;
  text-decoration: none;
  transition: var(--default-transition);
}
.social-icon-style-01.dark a:hover {
  color: var(--social-icon-color);
}
.social-icon-style-01.light a {
  color: white;
  text-decoration: none;
  transition: var(--default-transition);
}
.social-icon-style-01.light a:hover {
  color: var(--social-icon-color);
}

.social-icon-style-02 {
  display: flex;
  align-items: center;
}
.social-icon-style-02.dark a, .social-icon-style-02.light a {
  transition: var(--default-transition);
}
.social-icon-style-02.dark a:hover, .social-icon-style-02.light a:hover {
  transform: translateY(-8px);
  color: var(--social-icon-color);
}

.social-icon-style-03 {
  display: flex;
  align-items: center;
}
.social-icon-style-03 a {
  background-color: var(--social-icon-color);
  transition: var(--default-transition);
}
.social-icon-style-03 a:hover {
  border-radius: 50%;
}

.social-icon-style-04 {
  display: flex;
  align-items: center;
}
.social-icon-style-04 a {
  background-color: var(--social-icon-color);
  transition: var(--default-transition);
  border-radius: 50%;
}
.social-icon-style-04 a:hover {
  color: var(--social-icon-color);
  background-color: #fff;
  transform: translate3d(0, -3px, 0);
  box-shadow: 0 0 30px rgba(23, 23, 23, 0.25);
}

.social-icon-style-05 {
  display: flex;
  align-items: center;
}
.social-icon-style-05 a {
  display: inline-block;
  border-radius: 100%;
  position: relative;
  color: #232323;
  text-align: center;
  z-index: 1;
  font-size: 24px;
  width: 60px;
  height: 60px;
}
.social-icon-style-05 a span {
  border-radius: 0;
  display: block;
  height: 0;
  left: 50%;
  margin: 0;
  position: absolute;
  top: 50%;
  transition: var(--default-transition);
  width: 0;
  z-index: -1;
  background-color: var(--social-icon-color);
}
.social-icon-style-05 a:hover {
  color: #fff;
}
.social-icon-style-05 a:hover span {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  top: 0;
  left: 0;
}

.social-icon-style-06 {
  display: flex;
  align-items: center;
}
.social-icon-style-06 a {
  transition: var(--default-transition);
  border-radius: 0;
}
.social-icon-style-06 a:hover {
  color: #fff;
  background-color: var(--social-icon-color);
  border-radius: 50%;
}

.social-icon-style-07 {
  display: flex;
  align-items: center;
}
.social-icon-style-07.dark a, .social-icon-style-07.light a {
  color: var(--social-icon-color);
  transition: var(--default-transition);
}
.social-icon-style-07.dark a:hover {
  color: #232323;
}
.social-icon-style-07.light a:hover {
  color: #fff;
}

.social-icon-style-08 {
  display: flex;
  align-items: center;
  width: 100%;
}
.social-icon-style-08.dark a, .social-icon-style-08.light a {
  color: var(--social-icon-color);
  display: inline-block;
  height: auto;
  width: auto;
  padding: 0 24px;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  transition: 350ms cubic-bezier(0.175, 0.885, 0.32, 1.275) all;
}
.social-icon-style-08.dark a .brand-icon, .social-icon-style-08.light a .brand-icon {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 100%;
  font-size: 20px;
  line-height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition-duration: 0.3s;
  transition: 350ms cubic-bezier(0.175, 0.885, 0.32, 1.275) all;
}
.social-icon-style-08.dark a:hover .brand-icon, .social-icon-style-08.light a:hover .brand-icon {
  top: 0;
  transition-duration: 0.3s;
}
.social-icon-style-08.dark a:hover > span.brand-label, .social-icon-style-08.light a:hover > span.brand-label {
  top: -50px;
  transition: var(--default-transition);
  transition-duration: 350ms;
}
.social-icon-style-08.dark a > span, .social-icon-style-08.light a > span {
  font-family: var(--alt-font);
  font-size: 20px;
  line-height: 28px;
  line-height: inherit;
  font-weight: 500;
  top: 0;
  position: relative;
  transition: var(--default-transition);
  transition-duration: 350ms;
  transition: 350ms cubic-bezier(0.175, 0.885, 0.32, 1.275) all;
}

.social-icon-style-09 {
  display: flex;
  align-items: center;
}
.social-icon-style-09 a {
  display: inline-block;
  border-radius: 100%;
  color: #232323;
  position: relative;
  text-align: center;
  transition: var(--default-transition);
}
.social-icon-style-09 a:hover {
  color: white;
  background-color: var(--social-icon-color);
}
.social-icon-style-09 a:hover:after {
  opacity: 0.4;
  transform: scale(1.3);
}
.social-icon-style-09 a:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transform: scale(0.8);
  border: 1px solid;
  border-radius: 100%;
  opacity: 0;
  border-color: var(--social-icon-color);
  color: var(--social-icon-color);
  transition: var(--default-transition);
  transition-duration: 0.5s;
}

.social-icon-style-10 {
  display: flex;
  align-items: center;
}
.social-icon-style-10.dark a, .social-icon-style-10.light a {
  display: inline-block;
  position: relative;
  z-index: 3;
  overflow: hidden;
  text-align: center;
  font-size: 24px;
  width: 60px;
  height: 60px;
  color: var(--social-icon-color);
  transition: 0.3s ease-in-out;
}
.social-icon-style-10.dark a:hover, .social-icon-style-10.light a:hover {
  color: #fff;
}
.social-icon-style-10.dark a:hover > span, .social-icon-style-10.light a:hover > span {
  background-color: var(--social-icon-color);
  top: 0;
  z-index: -1;
}
.social-icon-style-10.dark a > span, .social-icon-style-10.light a > span {
  position: absolute;
  top: -100%;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  transition: var(--default-transition);
  transition-duration: 0.5s;
  transition: 0.3s ease-in-out;
}
.social-icon-style-10.dark a {
  color: #000;
}
.social-icon-style-10.light a:hover {
  color: #fff;
}

.social-icon-style-11 {
  display: flex;
  align-items: center;
}
@media (max-width: var(--md)) {
  .social-icon-style-11 {
    width: 80%;
    justify-content: center;
    display: inline-block;
  }
}
.social-icon-style-11 li {
  margin-right: 0 !important;
  margin-left: 0 !important;
  margin-bottom: 0 !important;
}
.social-icon-style-11.dark a, .social-icon-style-11.light a {
  display: inline-block;
  vertical-align: middle;
  height: 160px;
  width: 160px;
  position: relative;
  margin: 0 15px;
  margin-bottom: 1rem !important;
  transition: var(--default-transition);
  color: #828282;
  text-decoration: none;
}
.social-icon-style-11.dark a:hover, .social-icon-style-11.light a:hover {
  text-decoration: none;
  outline: 0;
  outline-offset: 0;
  color: #0038e3;
}
.social-icon-style-11.dark a:hover .social-front, .social-icon-style-11.light a:hover .social-front {
  transition-duration: 0.3s;
  background-color: #fff;
  text-align: center;
  box-shadow: 0 0 35px rgba(23, 23, 23, 0.06);
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.social-icon-style-11.dark a:hover .top-left, .social-icon-style-11.light a:hover .top-left {
  top: 0;
  left: 0;
}
.social-icon-style-11.dark a:hover .top, .social-icon-style-11.light a:hover .top {
  top: 0;
}
.social-icon-style-11.dark a:hover .top-right, .social-icon-style-11.light a:hover .top-right {
  top: 0;
  left: 60px;
}
.social-icon-style-11.dark .social-back, .social-icon-style-11.light .social-back {
  background-color: var(--social-icon-color);
  position: relative;
  height: 140px;
  width: 140px;
  padding: 30px;
  top: 30px;
  left: 30px;
  line-height: 2;
}
.social-icon-style-11.dark .social-back span, .social-icon-style-11.light .social-back span {
  position: absolute;
  bottom: 3px;
  right: 30px;
  text-transform: uppercase;
  color: #fff;
  font-size: 11px;
  line-height: 14px;
}
.social-icon-style-11.dark .social-front, .social-icon-style-11.light .social-front {
  background-color: #fff;
  text-align: center;
  transition-duration: 0.3s;
  box-shadow: 0 0 35px rgba(23, 23, 23, 0.06);
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 140px;
  width: 140px;
  padding: 30px;
  position: absolute;
  top: 30px;
  left: 30px;
}
.social-icon-style-11.dark .social-front i, .social-icon-style-11.light .social-front i {
  color: var(--social-icon-color);
  display: block;
  margin: 0 0 20px 0;
  font-size: 28px;
  font-weight: 400;
  display: inline-block;
  line-height: 1;
}
.social-icon-style-11.dark .social-front span, .social-icon-style-11.light .social-front span {
  display: block;
  color: #232323;
  font-size: 12px;
  line-height: 16px;
  font-family: var(--alt-font);
  text-transform: uppercase;
}

.social-icon-style-12 {
  display: flex;
  align-items: center;
}
.social-icon-style-12 a {
  transition: var(--default-transition);
}
.social-icon-style-12 a i {
  color: var(--social-icon-color);
}
.social-icon-style-12 a:hover {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/Assets/scss/components/_socialicons.scss"],"names":[],"mappings":"AAAA,sBAAA;AAGI;EACE,cAAA;AADN;AAMI;EACE,WAAA;AAJN;AAQE;EAKE,gBAAA;EACA,UAAA;AAVJ;AAYI;EACE,qBAAA;AAVN;AAYM;EACE,cAAA;AAVR;AAaM;EACE,eAAA;AAXR;AAeI;EACE,qBAAA;AAbN;AAkBI;EACE,aAAA;AAhBN;AAmBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjBN;AAsBI;EACE,aAAA;AApBN;AAuBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AArBN;AA0BI;EACE,aAAA;AAxBN;AA2BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAzBN;AA8BI;EACE,iBAAA;EACA,kBAAA;AA5BN;AA+BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA7BN;AAkCI;EACE,cAAA;AAhCN;AAmCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAjCN;;AAuCA;EACE,aAAA;EACA,mBAAA;AApCF;AAuCI;EACE,cAAA;EACA,qBAAA;EACA,qCAAA;AArCN;AAuCM;EACE,+BAAA;AArCR;AA2CI;EACE,YAAA;EACA,qBAAA;EACA,qCAAA;AAzCN;AA2CM;EACE,+BAAA;AAzCR;;AAgDA;EACE,aAAA;EACA,mBAAA;AA7CF;AAiDI;EACE,qCAAA;AA/CN;AAiDM;EACE,2BAAA;EACA,+BAAA;AA/CR;;AAsDA;EACE,aAAA;EACA,mBAAA;AAnDF;AAqDE;EACE,0CAAA;EACA,qCAAA;AAnDJ;AAqDI;EACE,kBAAA;AAnDN;;AAyDA;EACE,aAAA;EACA,mBAAA;AAtDF;AAwDE;EACE,0CAAA;EACA,qCAAA;EACA,kBAAA;AAtDJ;AAwDI;EACE,+BAAA;EACA,sBAAA;EACA,kCAAA;EACA,2CAAA;AAtDN;;AA4DA;EACE,aAAA;EACA,mBAAA;AAzDF;AA2DE;EAEE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAzDJ;AA2DI;EACE,gBAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,qCAAA;EACA,QAAA;EACA,WAAA;EACA,0CAAA;AAzDN;AA4DI;EACE,WAAA;AA1DN;AA4DM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;AA1DR;;AAiEA;EACE,aAAA;EACA,mBAAA;AA9DF;AAgEE;EACE,qCAAA;EACA,gBAAA;AA9DJ;AAgEI;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;AA9DN;;AAoEA;EACE,aAAA;EACA,mBAAA;AAjEF;AAqEI;EACE,+BAAA;EACA,qCAAA;AAnEN;AAyEM;EACE,cAAA;AAvER;AA8EM;EACE,WAAA;AA5ER;;AAmFA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAhFF;AAoFI;EACE,+BAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,6DAAA;AAlFN;AAoFM;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6DAAA;AAlFR;AAsFQ;EACE,MAAA;EACA,yBAAA;AApFV;AAuFQ;EACE,UAAA;EACA,qCAAA;EACA,0BAAA;AArFV;AAyFM;EACE,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,MAAA;EACA,kBAAA;EACA,qCAAA;EACA,0BAAA;EACA,6DAAA;AAvFR;;AA8FA;EACE,aAAA;EACA,mBAAA;AA3FF;AA6FE;EAEE,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;AA3FJ;AA6FI;EACE,YAAA;EACA,0CAAA;AA3FN;AA6FM;EACE,YAAA;EAKA,qBAAA;AA3FR;AA+FI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,sCAAA;EACA,+BAAA;EACA,qCAAA;EACA,yBAAA;AA7FN;;AAmGA;EACE,aAAA;EACA,mBAAA;AAhGF;AAoGI;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,4BAAA;AAlGN;AAoGM;EACE,WAAA;AAlGR;AAoGQ;EACE,0CAAA;EACA,MAAA;EACA,WAAA;AAlGV;AAsGM;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,yBAAA;EACA,4BAAA;AApGR;AA0GI;EACE,WAAA;AAxGN;AA8GM;EAEE,WAAA;AA7GR;;AAoHA;EACE,aAAA;EACA,mBAAA;AAjHF;AAmHE;EAJF;IAKI,UAAA;IACA,uBAAA;IACA,qBAAA;EAhHF;AACF;AAkHE;EACE,0BAAA;EACA,yBAAA;EACA,2BAAA;AAhHJ;AAqHI;EACE,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;EACA,qCAAA;EACA,cAAA;EACA,qBAAA;AAnHN;AAqHM;EACE,qBAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AAnHR;AAqHQ;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,2CAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AAnHV;AAsHQ;EACE,MAAA;EACA,OAAA;AApHV;AAuHQ;EACE,MAAA;AArHV;AAwHQ;EACE,MAAA;EACA,UAAA;AAtHV;AA2HI;EACE,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;AAzHN;AA2HM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AAzHR;AA6HI;EACE,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2CAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AA3HN;AA6HM;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AA3HR;AA8HM;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,yBAAA;AA5HR;;AAmIA;EACE,aAAA;EACA,mBAAA;AAhIF;AAkIE;EACE,qCAAA;AAhIJ;AAkII;EACE,+BAAA;AAhIN;AAmII;EACE,YAAA;AAjIN","sourcesContent":["/* social media icon */\n.social-icon {\n  &.dark {\n    a {\n      color: #232323;\n    }\n  }\n\n  &.light {\n    a {\n      color: #fff;\n    }\n  }\n\n  &.xs,\n  &.sm,\n  &.md,\n  &.lg,\n  &.xl {\n    list-style: none;\n    padding: 0;\n\n    li {\n      display: inline-block;\n\n      &:first-child {\n        margin-left: 0;\n      }\n\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n\n    a {\n      display: inline-block;\n    }\n  }\n\n  &.xs {\n    li {\n      margin: 0 2px;\n    }\n\n    a {\n      font-size: 14px;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n    }\n  }\n\n  &.sm {\n    li {\n      margin: 0 5px;\n    }\n\n    a {\n      font-size: 16px;\n      width: 40px;\n      height: 40px;\n      line-height: 40px;\n    }\n  }\n\n  &.md {\n    li {\n      margin: 0 8px;\n    }\n\n    a {\n      font-size: 20px;\n      width: 50px;\n      height: 50px;\n      line-height: 50px;\n    }\n  }\n\n  &.lg {\n    li {\n      margin-left: 10px;\n      margin-right: 10px;\n    }\n\n    a {\n      font-size: 24px;\n      width: 60px;\n      height: 60px;\n      line-height: 60px;\n    }\n  }\n\n  &.xl {\n    li {\n      margin: 0 12px;\n    }\n\n    a {\n      font-size: 30px;\n      width: 70px;\n      height: 70px;\n      line-height: 70px;\n    }\n  }\n}\n\n// Social Icon Style 01\n.social-icon-style-01 {\n  display: flex;\n  align-items: center;\n\n  &.dark {\n    a {\n      color: #232323;\n      text-decoration: none;\n      transition: var(--default-transition);\n\n      &:hover {\n        color: var(--social-icon-color);\n      }\n    }\n  }\n\n  &.light {\n    a {\n      color: white;\n      text-decoration: none;\n      transition: var(--default-transition);\n\n      &:hover {\n        color: var(--social-icon-color);\n      }\n    }\n  }\n}\n\n// Social Icon Style 02\n.social-icon-style-02 {\n  display: flex;\n  align-items: center;\n\n  &.dark,\n  &.light {\n    a {\n      transition: var(--default-transition);\n\n      &:hover {\n        transform: translateY(-8px);\n        color: var(--social-icon-color);\n      }\n    }\n  }\n}\n\n// Social Icon Style 03\n.social-icon-style-03 {\n  display: flex;\n  align-items: center;\n\n  a {\n    background-color: var(--social-icon-color);\n    transition: var(--default-transition);\n\n    &:hover {\n      border-radius: 50%;\n    }\n  }\n}\n\n// Social Icon Style 04\n.social-icon-style-04 {\n  display: flex;\n  align-items: center;\n\n  a {\n    background-color: var(--social-icon-color);\n    transition: var(--default-transition);\n    border-radius: 50%;\n\n    &:hover {\n      color: var(--social-icon-color);\n      background-color: #fff;\n      transform: translate3d(0, -3px, 0);\n      box-shadow: 0 0 30px rgb(23 23 23 / 25%);\n    }\n  }\n}\n\n// Social Icon Style 05\n.social-icon-style-05 {\n  display: flex;\n  align-items: center;\n\n  a {\n    text-align: center;\n    display: inline-block;\n    border-radius: 100%;\n    position: relative;\n    color: #232323;\n    text-align: center;\n    z-index: 1;\n    font-size: 24px;\n    width: 60px;\n    height: 60px;\n\n    span {\n      border-radius: 0;\n      display: block;\n      height: 0;\n      left: 50%;\n      margin: 0;\n      position: absolute;\n      top: 50%;\n      transition: var(--default-transition);\n      width: 0;\n      z-index: -1;\n      background-color: var(--social-icon-color);\n    }\n\n    &:hover {\n      color: #fff;\n\n      span {\n        width: 100%;\n        height: 100%;\n        border-radius: 100%;\n        top: 0;\n        left: 0;\n      }\n    }\n  }\n}\n\n// Social Icon Style 06\n.social-icon-style-06 {\n  display: flex;\n  align-items: center;\n\n  a {\n    transition: var(--default-transition);\n    border-radius: 0;\n\n    &:hover {\n      color: #fff;\n      background-color: var(--social-icon-color);\n      border-radius: 50%;\n    }\n  }\n}\n\n// Social Icon Style 07\n.social-icon-style-07 {\n  display: flex;\n  align-items: center;\n\n  &.dark,\n  &.light {\n    a {\n      color: var(--social-icon-color);\n      transition: var(--default-transition);\n    }\n  }\n\n  &.dark {\n    a {\n      &:hover {\n        color: #232323;\n      }\n    }\n  }\n\n  &.light {\n    a {\n      &:hover {\n        color: #fff;\n      }\n    }\n  }\n}\n\n// Social Icon Style 08\n.social-icon-style-08 {\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  &.dark,\n  &.light {\n    a {\n      color: var(--social-icon-color);\n      display: inline-block;\n      height: auto;\n      width: auto;\n      padding: 0 24px;\n      position: relative;\n      overflow: hidden;\n      text-decoration: none;\n      transition: 350ms cubic-bezier(0.175, 0.885, 0.32, 1.275) all;\n\n      .brand-icon {\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        left: 0;\n        top: 100%;\n        font-size: 20px;\n        line-height: 28px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        transition-duration: 0.3s;\n        transition: 350ms cubic-bezier(0.175, 0.885, 0.32, 1.275) all;\n      }\n\n      &:hover {\n        .brand-icon {\n          top: 0;\n          transition-duration: 0.3s;\n        }\n\n        >span.brand-label {\n          top: -50px;\n          transition: var(--default-transition);\n          transition-duration: 350ms;\n        }\n      }\n\n      >span {\n        font-family: var(--alt-font);\n        font-size: 20px;\n        line-height: 28px;\n        line-height: inherit;\n        font-weight: 500;\n        top: 0;\n        position: relative;\n        transition: var(--default-transition);\n        transition-duration: 350ms;\n        transition: 350ms cubic-bezier(0.175, 0.885, 0.32, 1.275) all;\n      }\n    }\n  }\n}\n\n// Social Icon Style 09\n.social-icon-style-09 {\n  display: flex;\n  align-items: center;\n\n  a {\n    text-align: center;\n    display: inline-block;\n    border-radius: 100%;\n    color: #232323;\n    position: relative;\n    text-align: center;\n    transition: var(--default-transition);\n\n    &:hover {\n      color: white;\n      background-color: var(--social-icon-color);\n\n      &:after {\n        opacity: 0.4;\n        -webkit-transform: scale(1.3);\n        -moz-transform: scale(1.3);\n        -ms-transform: scale(1.3);\n        -o-transform: scale(1.3);\n        transform: scale(1.3);\n      }\n    }\n\n    &:after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n      transform: scale(0.8);\n      border: 1px solid;\n      border-radius: 100%;\n      opacity: 0;\n      border-color: var(--social-icon-color);\n      color: var(--social-icon-color);\n      transition: var(--default-transition);\n      transition-duration: 0.5s;\n    }\n  }\n}\n\n// Social Icon Style 10\n.social-icon-style-10 {\n  display: flex;\n  align-items: center;\n\n  &.dark,\n  &.light {\n    a {\n      display: inline-block;\n      position: relative;\n      z-index: 3;\n      overflow: hidden;\n      text-align: center;\n      font-size: 24px;\n      width: 60px;\n      height: 60px;\n      color: var(--social-icon-color);\n      transition: 0.3s ease-in-out;\n\n      &:hover {\n        color: #fff;\n\n        >span {\n          background-color: var(--social-icon-color);\n          top: 0;\n          z-index: -1;\n        }\n      }\n\n      >span {\n        position: absolute;\n        top: -100%;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        z-index: -1;\n        transition: var(--default-transition);\n        transition-duration: 0.5s;\n        transition: 0.3s ease-in-out;\n      }\n    }\n  }\n\n  &.dark {\n    a {\n      color: #000;\n    }\n  }\n\n  &.light {\n    a {\n      &:hover {\n\n        color: #fff;\n      }\n    }\n  }\n}\n\n// Social Icon Style 11\n.social-icon-style-11 {\n  display: flex;\n  align-items: center;\n\n  @media (max-width:var(--md)) {\n    width: 80%;\n    justify-content: center;\n    display: inline-block;\n  }\n\n  li {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  &.dark,\n  &.light {\n    a {\n      display: inline-block;\n      vertical-align: middle;\n      height: 160px;\n      width: 160px;\n      position: relative;\n      margin: 0 15px;\n      margin-bottom: 1rem !important;\n      transition: var(--default-transition);\n      color: #828282;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: none;\n        outline: 0;\n        outline-offset: 0;\n        color: #0038e3;\n\n        .social-front {\n          transition-duration: 0.3s;\n          background-color: #fff;\n          text-align: center;\n          box-shadow: 0 0 35px rgba(23, 23, 23, 0.06);\n          display: flex;\n          justify-content: center;\n          flex-direction: column;\n        }\n\n        .top-left {\n          top: 0;\n          left: 0;\n        }\n\n        .top {\n          top: 0;\n        }\n\n        .top-right {\n          top: 0;\n          left: 60px;\n        }\n      }\n    }\n\n    .social-back {\n      background-color: var(--social-icon-color);\n      position: relative;\n      height: 140px;\n      width: 140px;\n      padding: 30px;\n      top: 30px;\n      left: 30px;\n      line-height: 2;\n\n      span {\n        position: absolute;\n        bottom: 3px;\n        right: 30px;\n        text-transform: uppercase;\n        color: #fff;\n        font-size: 11px;\n        line-height: 14px;\n      }\n    }\n\n    .social-front {\n      background-color: #fff;\n      text-align: center;\n      transition-duration: 0.3s;\n      box-shadow: 0 0 35px rgb(23 23 23 / 6%);\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n      height: 140px;\n      width: 140px;\n      padding: 30px;\n      position: absolute;\n      top: 30px;\n      left: 30px;\n\n      i {\n        color: var(--social-icon-color);\n        display: block;\n        margin: 0 0 20px 0;\n        font-size: 28px;\n        font-weight: 400;\n        display: inline-block;\n        line-height: 1;\n      }\n\n      span {\n        display: block;\n        color: #232323;\n        font-size: 12px;\n        line-height: 16px;\n        font-family: var(--alt-font);\n        text-transform: uppercase;\n      }\n    }\n  }\n}\n\n// Social Icon Style 12\n.social-icon-style-12 {\n  display: flex;\n  align-items: center;\n\n  a {\n    transition: var(--default-transition);\n\n    i {\n      color: var(--social-icon-color);\n    }\n\n    &:hover {\n      opacity: 0.5;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
